import LocationAdapter from 'shared/location_adapter';
import DateTimeHelper from "commons/Utils/DateTimeHelper";

export default class LivestreamingCountdown {
  constructor({ element: element }) {
    this._element = element;
  }

  element() {
    return this._element;
  }

  livestreamStart() {
    return Number(this.element().getAttribute('data-livestreaming-start')) * 1000;
  }

  timerElement() {
    return this.element().querySelector('.ls-countdown-timer');
  }

  init() {
    if (this.getRemainingTime() > 0) {
      this.updateElement();
      this.showElement();
      this.startCountdown();
    }
  }

  livestreamStartDate() {
    return (new Date(this.livestreamStart()));
  }

  getRemainingTime() {
    return (this.livestreamStartDate() - DateTimeHelper.now()) / 1000;
  }

  getFormattedRemainingTime() {
    const remainingTime = this.getRemainingTime();
    const remainingHour = Math.floor(remainingTime / 3600);

    if (remainingHour > 24) {
      return this.formatRemainingDay(this.livestreamStartDate());
    }

    return DateTimeHelper.formatRemainingTime(remainingTime);
  }

  formatRemainingDay(liveDate) {
    return DateTimeHelper.formatRemainingDay(liveDate);
  }

  updateElement() {
    this.timerElement().textContent = this.getFormattedRemainingTime();
  }

  showElement() {
    this.element().classList.remove('hidden');
  }

  startCountdown() {
    const interval = setInterval(() => {
      if (this.getRemainingTime() <= 0) {
        clearInterval(interval);
        this.reloadPage();
      }
      this.updateElement();
    }, 1000);
  }

  currentUrl() {
    return window.location.href;
  }

  currentSearch(){
    return window.location.search;
  }

  reloadPage() {
    if (this.element().dataset.reloadPage === 'false') {
      return;
    }
    let currentParamsExist = this.currentSearch() != '';
    let params = currentParamsExist ? '&ref=countdown' : '?ref=countdown';
    LocationAdapter.href(this.currentUrl() + params);
  }
}
